<template>
    <b-modal size="sm" centered hide-header hide-footer body-class="p-0" ref="modal-device-notes" @shown="resize">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img :src="require(`@/assets/img/devices/${icon}.png`)">
                <p class="text-light m-0 fs-4 ms-2">{{ plate }}</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg">
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <b-button type="submit" variant="primary" class="d-flex justify-content-center align-items-center py-1" style="width: max-content;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#fff" style="height: 15px;"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                    <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                </svg>
                <p class="m-0 ms-1" style="font-size: 15px" @click="showCreateNote">Agregar Nota</p>
            </b-button>
            <div class="d-flex flex-column overflow-auto align-items-center mt-2" id="box-notes">
                <CreateNote @saveNote="saveNote" ref="create-note"></CreateNote>
                <UpdateNote @updateNote="updateNote" ref="update-note"></UpdateNote>
                <div class="note w-100 mb-2" v-for="(note, index) in notes" :key="note.id">
                    <div class="note-header d-flex flex-row w-100 p-2 px-3" :style="{ background: getColorNote(index).header }">
                        <p class="note-title d-flex m-0 fw-bold" style="width: 80%;">{{ note.title }}</p>
                        <div class="note-actions d-flex flex-row align-items-center justify-content-end" style="width: 20%;">
                            <svg @click="showUpdateNote(note.id || 0)" xmlns="http://www.w3.org/2000/svg" :style="{ fill: getColorNote(index).strong }" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z" />
                            </svg>
                            <svg @click="removeNote(note.id || 0)" xmlns="http://www.w3.org/2000/svg" :style="{ fill: getColorNote(index).strong }" class="ms-3" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                            </svg>
                        </div>
                    </div>
                    <div class="note-body d-flex flex-column w-100 p-2 px-3" :style="{ background: getColorNote(index).body }">
                        <p class="note-text m-0">{{ note.message }}</p>
                        <div class="note-date d-flex flex-row justify-content-end w-100 px-1" style="font-size: 14px">
                            <p class="m-0 fw-bold" :style="{ color: getColorNote(index).strong }">{{ note.created_at }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script lang="ts">
import NoteService from '@/api/services/note.service';
import { noteColors } from '@/models/colors/note-colors';
import INoteDto from '@/models/dto/INote.dto';
import DateUtil from '@/utils/date.util';
import { Component, Vue } from 'vue-property-decorator';
import CreateNote from './CreateNote.vue';
import UpdateNote from './UpdateNote.vue';

@Component({
    components: { CreateNote, UpdateNote }
})
export default class DeviceNotes extends Vue {

    icon = '0'
    plate = 'NaN'
    notes: INoteDto[] = []
    deviceId = 0

    close() {
        const modal: any = this.$refs['modal-device-notes']
        modal.hide();
    }

    async show(deviceId: number) {
        const modal: any = this.$refs['modal-device-notes']
        modal.show()
        this.notes = []
        const notes: INoteDto[] = (await NoteService.getAllNotes(deviceId)).data
        notes.map(item => item.created_at = DateUtil.getGenericFormat(item.created_at))
        this.notes = notes
        this.deviceId = deviceId
    }

    resize() {
        const el: any = document.getElementById('box-notes')
        el.style.maxHeight = `${window.innerHeight - 220}px`
    }

    getColorNote(index: number) {
        return noteColors[index % 4]
    }

    showCreateNote() {
        const modal: any = this.$refs['create-note']
        modal.note.deviceid = this.deviceId
        modal.note.message = ""
        modal.note.title = ""
        modal.show()
    }

    showUpdateNote(noteId: number) {
        const modal: any = this.$refs['update-note']
        const note = this.notes.find(item => item.id == noteId)
        modal.note.deviceid = note?.deviceid
        modal.note.message = note?.message
        modal.note.title = note?.title
        modal.note.id = note?.id
        modal.note.attributes = note?.attributes
        modal.show()
    }

    async saveNote(note: INoteDto) {
        const modal: any = this.$refs['create-note']
        this.notes.unshift(note)
        modal.close()
    }

    async updateNote(note: INoteDto) {
        const modal: any = this.$refs['update-note']
        console.log(note)
        this.notes = this.notes.map(item => {
            if (item.id == note.id) {
                item = note
            }
            return item
        })
        // this.notes.unshift(note)
        modal.close()
    }

    async removeNote(noteId: number) {
        await NoteService.removeNote(noteId)
            .then(() => {
                this.notes = this.notes.filter(item => item.id != noteId)
            }).catch(() => {
                console.log('Error in remove')
            })
    }
}
</script>

<style lang="sass">
    .box-notes
        overflow: auto !important
    .note
        .note-header
            svg
                height: 20px !important
            .note-title
                font-size: 16px
            .note-actions
                svg
                    transition: all 0.1s ease
                    cursor: pointer
                    &:active
                        transform: scale(0.9)
        .note-body
            .note-text
                font-size: 12px !important
                text-align: justify
                
            .note-date
                p
                    font-size: 14px !important
    .modal-header
        height: 60px !important
        img
            height: 45px

    .close-modal
        height: 20px
        cursor: pointer
        transition: all .1s ease
        &:active
            transform: scale(0.9)
            
        img
            height: 100%

</style>